"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _ReleaseType = require("@/lib/enum/ReleaseType");
var _auth = require("@/utils/auth");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      releaseTypeOptions: _ReleaseType.ReleaseTypeList
    };
  },
  computed: {
    searchRecruitmentText: {
      get: function get() {
        return this.$store.getters.searchRecruitmentText;
      },
      set: function set(val) {
        this.$store.dispatch('recruitment/setRecruitmentText', val);
      }
    },
    searchActive: {
      get: function get() {
        return this.$store.getters.searchActive;
      },
      set: function set(val) {
        this.$store.dispatch('recruitment/setSearchActive', val);
      }
    }
  },
  methods: {
    searchRecruitment: function () {
      var _searchRecruitment = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              console.log('searchRecruitment');
              _context.next = 1;
              return this.$store.dispatch('recruitment/setPageTop', 0);
            case 1:
              _context.next = 2;
              return this.$store.dispatch('recruitment/fetchRecruitments', (0, _auth.getUUID)());
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function searchRecruitment() {
        return _searchRecruitment.apply(this, arguments);
      }
      return searchRecruitment;
    }()
  }
};